// Bloque de campos "financiación" reutilizado en publicar/editar oferta:
// cuotas (+ sin interés), promo tipo 2x1/3x2 y selector de tarjetas
// aceptadas (con logo). Todo opcional: si el vendedor no completa nada, no
// se guarda/muestra nada en la oferta.
import React from "react";
import {
  Box,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  FormGroup,
  Grid,
} from "@mui/material";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";
import { CARD_OPTIONS } from "./paymentCards";

const cardChipSx = (selected) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.5,
  width: 76,
  py: 1,
  px: 0.5,
  borderRadius: "8px",
  cursor: "pointer",
  border: `2px solid ${selected ? brandColors.accent : brandColors.divider}`,
  backgroundColor: selected ? `${brandColors.accent}22` : "transparent",
  transition: "border-color 0.15s ease, background-color 0.15s ease",
});

const PaymentInfoFields = ({ value, onChange }) => {
  const { installments = "", installmentsNoInterest = false, promo = "", acceptedCards = [] } = value;

  const set = (patch) => onChange({ ...value, ...patch });

  const toggleCard = (cardId) => {
    const next = acceptedCards.includes(cardId)
      ? acceptedCards.filter((id) => id !== cardId)
      : [...acceptedCards, cardId];
    set({ acceptedCards: next });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, color: brandColors.textSecondary }}>
        <T>Financiación (opcional)</T>
      </Typography>

      <Grid container spacing={1.5}>
        <Grid item xs={6}>
          <TextField
            margin="dense"
            id="installments"
            label={<T>Cuotas (ej: 12)</T>}
            type="text"
            fullWidth
            name="installments"
            value={installments}
            onChange={(e) => {
              const v = e.target.value;
              if (/^\d*$/.test(v)) set({ installments: v });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="dense"
            id="promo"
            label={<T>Promoción (ej: 2x1, 3x2)</T>}
            type="text"
            fullWidth
            name="promo"
            value={promo}
            onChange={(e) => set({ promo: e.target.value })}
          />
        </Grid>
      </Grid>

      <FormControlLabel
        sx={{ mt: 0.5, display: "flex" }}
        control={
          <Switch
            checked={installmentsNoInterest}
            onChange={(e) => set({ installmentsNoInterest: e.target.checked })}
          />
        }
        label={<T>Cuotas sin interés</T>}
      />

      <Typography variant="caption" sx={{ display: "block", mt: 1.5, mb: 1, color: brandColors.textSecondary }}>
        <T>Tarjetas que acepta</T>
      </Typography>
      <FormGroup row sx={{ gap: 1 }}>
        {CARD_OPTIONS.map((card) => {
          const selected = acceptedCards.includes(card.id);
          return (
            <Box key={card.id} sx={cardChipSx(selected)} onClick={() => toggleCard(card.id)}>
              <Box component="img" src={card.img} alt={card.label} sx={{ height: 22, objectFit: "contain" }} />
              <Typography variant="caption" sx={{ fontSize: "0.65rem", textAlign: "center", lineHeight: 1.1 }}>
                {card.label}
              </Typography>
            </Box>
          );
        })}
      </FormGroup>
    </Box>
  );
};

export default PaymentInfoFields;
